import React from 'react'
import { connect } from 'react-redux'
import {
  Form,
  Input,
  Select,
  Card,
  Table,
  Button,
  Row,
  Col,
  Radio,
  Space,
  Tooltip,
  Badge,
  Tag,
  Alert,
  Typography
} from 'antd'

import { PlusOutlined } from '@ant-design/icons'
import {
  API_BUILDER_LOCAL_RULE_FIELDS,
  API_BUILDER_LOCAL_RULE_FILTER,
  API_BUILDER_FOREIGN_RULE_FIELDS,
  API_BUILDER_FOREIGN_RULE_FILTER,
  API_BUILDER_LOCAL_RULE_SORT
} from './../../constants/constants'
import { Translation } from 'react-i18next'

const { Option, OptGroup } = Select
// const selectData = ['Contains']

const Child = ({ isLocal, data, index, removeItem, handleOnChange, t }) => {
  console.log(API_BUILDER_LOCAL_RULE_FILTER[data.key1], data.key1, 'checked')
  var FIELDS = isLocal ? API_BUILDER_LOCAL_RULE_FIELDS : API_BUILDER_FOREIGN_RULE_FIELDS
  var RULE_FILTER = isLocal ? API_BUILDER_LOCAL_RULE_FILTER : API_BUILDER_FOREIGN_RULE_FILTER

  return (

    <Translation>
      {(t, { i18n }) => (
        <div className={`apiSearch ${data.error && 'errorSearch'}`}>
          <div>
            <Form layout='vertical' aria-labelledby='id'>
              <ul>
                <li key={1}>
                  <span id="item_option" style={{ display: 'none' }}>{t("ITEM_OPTIONS")}</span>
                  <Form.Item label={t("ITEM")} style={{ marginBottom: 0 }} htmlFor='item'>
                    <Select //disabled={true}
                      id='item'
                      style={{ width: 250, }}
                      label={data.key1}
                      onChange={val => handleOnChange(index, val, 'key_1')}
                      value={data.key1}
                      // aria-label={`no2 no1`}
                      // aria-labelledby={`no2 no1`}
                      aria-labelledby={`item_option ${data.key1}`}
                      aria-describedby='alert'
                    // aria-label={data.key1}
                    >
                      {FIELDS(t).map(({ label, value }, i) => (
                        <Option key={i} value={value} >
                          <span id={value}>{label}</span>
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </li>
                <li key={2}
                  style={{
                    display: data.hasOwnProperty('key2') ? 'inline-block' : 'none'
                  }}
                >
                  <span id="filter_option" style={{ display: 'none' }}>{t("FILTER_OPTIONS")}</span>
                  <Form.Item label={t("FILTER")} style={{ marginBottom: 0 }} htmlFor='filter'>
                    <Select
                      style={{ width: 170, }}
                      id='filter'
                      // onChange={handleOnChange}
                      label={data.key2}
                      onChange={val => handleOnChange(index, val, 'key_2')}
                      value={data.key2}
                      aria-labelledby={`filter_option ${data.key2}`}
                      aria-describedby='alert'
                    // aria-labelledby={data.key2}
                    >
                      <OptGroup label={t("FILTER")} key={1}>
                        {(RULE_FILTER(t)[data.key1] || []).map(({ label, value }, i) => (
                          <Option key={`1${i}`} value={value}>
                            <span id={value}>{label}</span>
                          </Option>
                        ))}
                      </OptGroup>
                      {/* <OptGroup label='Sort' key={2}>
              {API_BUILDER_LOCAL_RULE_SORT.map(({ label, value }, i) => (
                <Option key={`2${i}`} value={value}>
                  {label}
                </Option>
              ))}
            </OptGroup> */}
                    </Select>
                  </Form.Item>
                </li>
                <li key={3}
                  style={{
                    display: data.hasOwnProperty('key3') ? 'inline-block' : 'none'
                  }}
                >
                  <Form.Item label={t("INPUT_VALUE")} style={{ marginBottom: 0 }} htmlFor='inputvalue' >
                    <Input value={data.key3} onChange={e => handleOnChange(index, e.target.value, 'key_3')} id='inputvalue' aria-describedby='alert' />
                  </Form.Item>
                </li>
                <li key={4} className='deleteBtnLi'>
                  {/* <Tooltip placement='bottom' title={t('DELETE')}>
            <Button type='danger' onClick={() => removeItem(index)} icon={<PlusOutlined  rotate={45}/>}>
              {t('DELETE')}
            </Button>
          </Tooltip> */}
                </li>
              </ul>
              {data.error && <span role='alert' id='alert' aria-describedby="alert" style={{ marginLeft: 8, color: '#cc0e00' }}> {t("ERROR_MSG")}</span>}
            </Form>
          </div>
        </div>
      )}
    </Translation>
  )
}

const Parent = props => {
  var { isLocal, data, handleDelete, handleAdd } = props
  // console.log(data)
  return (
    <div className='apiSearchSection '>
      <Row align='middle' justify='space-between'>
        <Col>
          <Tag color='rgb(53 71 94)'>{props.t('AND')}</Tag>
        </Col>
        <Col>
          {/* <Tooltip placement='bottom' title={props.t('ADD_RULE')}>
            <Button
              size='small'
              type='primary'
              className='btn-green'
              onClick={event => {
                handleAdd()
              }}
              icon={<PlusOutlined />}
            >
              {' '}
              {props.t('ADD_RULE')}
            </Button>
          </Tooltip> */}
        </Col>
      </Row>
      {Object.keys(data).map((key, i) => (
        <Child
          key={i}
          isLocal={isLocal}
          data={data[key]}
          index={key}
          removeItem={handleDelete}
          handleOnChange={props.handleOnChange}
          t={props.t}
        />
      ))}
    </div>
  )
}
const APISearchQuery = ({ t, handleOnChange, handleAddRule, handleDeleteRule, handleClickReset, handleClickGetResult, data, isLocal, columns, settingPaginationTotal }) => {
  return (
    <div className='apiSearchContainer'>
      <Parent
        handleOnChange={handleOnChange}
        handleAdd={handleAddRule}
        handleDelete={handleDeleteRule}
        data={data}
        isLocal={isLocal}
        t={t}
      />
      <Space size={0} className="groupBtn">
        <Tooltip placement='bottom' title={t('RESET')}>
          <Button
            type='danger'
            id='reset'
            onClick={event => handleClickReset()}
          >
            {' '}
            {t('RESET')}{' '}
          </Button>
        </Tooltip>
        <Tooltip placement='bottom' title={t('GET_RESULT')}>
          <Button
            type='primary'
            id='get_result'
            onClick={event => handleClickGetResult()}
          >
            {' '}
            {t('GET_RESULT')}{' '}
          </Button>
        </Tooltip>
      </Space>
    </div>
  )
}

export default APISearchQuery



// WEBPACK FOOTER //
// src/components/SearchResult/APISearchQuery.js